import { createSelector } from 'reselect';

import { convertFilterToQueryParam } from './utils';

export const location = (store) => store.router.location;

export const dateFilterQuery = createSelector([
  (store) => store.apps.archives.rdc.filters,
], (filters) => ({
  start_date: parseInt(filters.getIn(['filterDate', 'startDate']).getTime() / 1000, 10),
  end_date: parseInt(filters.getIn(['filterDate', 'endDate']).getTime() / 1000, 10),
}));

export const filtersQuery = createSelector([
  (store) => store.apps.archives.rdc.filters,
], (filters) => {
  const selectedFilters = filters.get('filters')
    .filter((filter) => filter.get('selectedItems').size).entries();
  const query = Array.from(selectedFilters).reduce((acc, [key, value]) => {
    let parsedValue = value.get('selectedItems').toArray();
    if (key === 'owner') {
      parsedValue = parsedValue.map((username) => filters.getIn(['users', username]));
    }
    if (key === 'team') {
      parsedValue = parsedValue.map((name) => filters.getIn(['teams', name]));
    }

    return {
      ...acc,
      ...convertFilterToQueryParam(key, parsedValue),
    };
  }, {});
  return query;
});

export const getQuerySelector = createSelector([
  (store) => store.apps.archives.rdc.filters,
], (filters) => {
  const selectedFilters = filters.get('filters')
    .filter((filter) => filter.get('selectedItems').size).entries();
  const selectedFiltersQuery = Array.from(selectedFilters).reduce((acc, [key, value]) => ({
    ...acc,
    [key]: value.get('selectedItems').toArray(),
  }), {});
  return {
    ...filters.get('query').toJS(),
    ...selectedFiltersQuery,
    startDate: filters.getIn(['filterDate', 'startDate']),
    endDate: filters.getIn(['filterDate', 'endDate']),
  };
});

export const fetchFiltersQuerySelector = createSelector([
  dateFilterQuery,
], (dateFilter) => ({
  ...dateFilter,
}));

export const filtersSelector = createSelector([
  (store) => store.apps.archives.rdc.filters,
  (store) => store.user,
], (filters, user) => ({
  filters: filters.get('filters'),
  filterDate: filters.get('filterDate'),
  jobsTeamSharingEnabled: user.isOrgAdmin() || user.organization.settings.jobs_cross_team_sharing,
}));
